import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import generalStyles from 'src/assets/styles/generalStyles.module.scss'
import fontStyles from 'src/assets/styles/fontStyles.module.scss'
import Button from 'src/components/Elements/Button'
import elementStyles from './elements.module.scss'

const TypeProps = {
  label: PropTypes.string,
  sublabel: PropTypes.string,
  isSponsor: PropTypes.bool
}

const ExchangeBusinessCardButton = ({ label, sublabel, isSponsor }) => {
  const { eventId } = useParams()
  const navigate = useNavigate()
  return (
    <div className={
      classNames(
        elementStyles.bizCardBtnContainer,
        isSponsor && elementStyles.bizCardBtnContainerSponsor
      )}
    >
      <div
        className={classNames(
          generalStyles.flexColumn,
          generalStyles.alignVertical,
          generalStyles.flexApart,
          isSponsor && generalStyles.mtn05
        )}
      >
        <div className={elementStyles.bizCardBtnContainerTitle}>
          <div className={generalStyles.flexColumn}>
            {label && <span className={fontStyles.pxsmallboldlssinneutral01whitegartnersans12pt}>{label}</span>}
            {sublabel && <span className={fontStyles.h5lsinneutral01whitegartnersans20pt}>{sublabel}</span>}
          </div>
          <div className={generalStyles.mr20}>
            <Button
              size={'med'}
              color={'darkBase'}
              onClick={() => navigate(`/programs/${eventId}/scanner${isSponsor ? '?sponsors' : '?attendees'}`)}
              label={'Scan'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

ExchangeBusinessCardButton.propTypes = {
  ...TypeProps
}

export default ExchangeBusinessCardButton
